export default __webpack_public_path__ + "static/media/anu.cb476b83.jpg";